import { makeStyles } from '@material-ui/styles';

export const useStyles = (maxWidth) =>
    makeStyles((theme) => ({
        row: {
            [`@media all and (max-width: ${maxWidth}px)`]: {
                height: '60px',
            },
        },
        secondRow: {
            background: theme.table.secondaryColor,
        },
    }));

export const seatScaleStyle = {
    margin: '0 -6px',
    transform: 'scale(0.7, 0.7)',
};

export const seatHalfScaleStyle = {
    margin: '0 -14px',
    transform: 'scale(0.5, 0.5)',
};
